import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/Login.css';
import { Link } from "react-router-dom";
import SEOHelmet from './SEOHelmet';

const Login = ({ onLoginSuccess }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [role, setRole] = useState('asset_incharge');
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Pre-fill email and show success message from signup
  useEffect(() => {
    if (location.state?.email) {
      setFormData(prev => ({
        ...prev,
        email: location.state.email
      }));
    }
    if (location.state?.message) {
      setSuccessMessage(location.state.message);
    }
  }, [location]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.email.trim()) {
      setError('Email is required');
      return;
    }

    if (!formData.password) {
      setError('Password is required');
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/auth/login`, {
        email: formData.email,
        password: formData.password,
        role
      });

      if (response.data.success) {
        sessionStorage.setItem('token', response.data.token);
     
        sessionStorage.setItem('user', JSON.stringify(response.data.user));
        onLoginSuccess(response.data.user);

        // Ensure app state updates before navigating — use a short delay for reliability
        if (role === 'asset_incharge') {
          navigate('/dashboard');
        } else if (role === 'asset_technician') {
          navigate('/technician-dashboard');
        } else if (role === 'asset_user') {
          navigate('/asset-user-dashboard');

        } else if (role === 'admin') {
          // Force a full navigation to ensure the admin dashboard loads cleanly
          setTimeout(() => {
            window.location.href = '/lab-admin/dashboard';
          }, 80);
        }
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <SEOHelmet page="login" canonicalUrl="https://www.assetflows.in/login" />
      <div className="login-card">
        <h1>Login to Asset Management System</h1>
        
        <div className="role-selector">
          <label>Login as:</label>
          <div className="role-buttons">
 <button
              type="button"
              className={`role-btn ${role === 'admin' ? 'active' : ''}`}
              onClick={() => {
                setRole('admin');
                setError('');
              }}
            >
               Admin
            </button>            
            
            <button
              type="button"
              className={`role-btn ${role === 'asset_incharge' ? 'active' : ''}`}
              onClick={() => {
                setRole('asset_incharge');
                setError('');
              }}
            >
              Asset Incharge
            </button>
            <button
              type="button"
              className={`role-btn ${role === 'asset_technician' ? 'active' : ''}`}
              onClick={() => {
                setRole('asset_technician');
                setError('');
              }}
            >
              Asset Technician
            </button>
            <button
              type="button"
              className={`role-btn ${role === 'asset_user' ? 'active' : ''}`}
              onClick={() => {
                setRole('asset_user');
                setError('');
              }}
            >
              Asset User
            </button>
           
          </div>
        </div>

        {successMessage && <div className="success-message" style={{color: '#27ae60', backgroundColor: '#d5f4e6', padding: '10px', borderRadius: '4px', marginBottom: '15px'}}>{successMessage}</div>}
        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password *</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter your password"
            />
          </div>

          <button 
            type="submit" 
            className="submit-btn"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <p className="signup-link">
          Don't have an account? <a href="/signup">Sign up here</a>
        </p>
          <p className="signup-link">
          Forgot Password? <Link to="/forgot-password">Reset here</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
